module.exports = __webpack_public_path__ + "img/calender2.b1b3f436.svg";